import React, { Fragment } from "react";
import { pluralise, toCurrency } from "@ecologi/shared";
import { TextField } from "../../TextField";
import styles from "../styles/CustomDonationForm.module.scss";

type Props = {
  customTotal: number;
  currencySymbol: string;
  customNumberOfOffsets: number;
  customNumberOfTrees: number;
  setCustomNumberOfOffsets: (num: number) => void;
  setCustomNumberOfTrees: (num: number) => void;
};

const MAX_TREES = 250000;
const MAX_OFFSETS = 10000;

export const CustomDonationForm: React.FC<Props> = (props) => {
  const {
    customTotal,
    currencySymbol,
    customNumberOfOffsets,
    customNumberOfTrees,
    setCustomNumberOfOffsets,
    setCustomNumberOfTrees,
  } = props;

  const total = toCurrency(customTotal);

  let purchaseOverviewCopy: string = "";

  if (customNumberOfTrees >= 25 && customNumberOfOffsets === 0) {
    purchaseOverviewCopy = `You'll be planting ${customNumberOfTrees} trees for ${currencySymbol}${total}!`;
  }
  if (customNumberOfOffsets >= 1 && customNumberOfTrees === 0) {
    purchaseOverviewCopy = `You'll be avoiding ${pluralise(
      customNumberOfOffsets,
      "tonne"
    )} of CO2e for ${currencySymbol}${total}!`;
  }
  if (customNumberOfOffsets >= 1 && customNumberOfTrees >= 25) {
    purchaseOverviewCopy = `You'll be planting ${customNumberOfTrees} trees and avoiding ${pluralise(
      customNumberOfOffsets,
      "tonne"
    )} of CO2e for ${currencySymbol}${total}!`;
  }

  return (
    <Fragment>
      <TextField
        errorText="The minimum number of trees you can buy is 25"
        isInvalid={customNumberOfTrees > 0 && customNumberOfTrees < 25}
        label="Number of trees to plant"
        onChange={(event) => {
          let _num = !!event.target.value ? parseInt(event.target.value) : 0;
          _num = _num < MAX_TREES ? _num : MAX_TREES;
          setCustomNumberOfTrees(_num);
        }}
        id="customTrees"
        name="customTrees"
        type="number"
        min={0}
        step={25}
        maxLength={MAX_TREES}
        value={customNumberOfTrees.toString()}
      />
      <TextField
        errorText="The minimum number of carbon avoidance tonnes you can buy is 1"
        label="Number of CO2e tonnes to avoid"
        min={0}
        step={1}
        max={MAX_OFFSETS}
        onChange={(event) => {
          let _num = !!event.target.value ? parseInt(event.target.value) : 0;
          _num = _num < MAX_OFFSETS ? _num : MAX_OFFSETS;
          setCustomNumberOfOffsets(_num);
        }}
        id="customOffsets"
        name="customOffsets"
        type="number"
        value={customNumberOfOffsets.toString()}
      />
      {purchaseOverviewCopy && (
        <div className={styles.totals}>{purchaseOverviewCopy}</div>
      )}
    </Fragment>
  );
};
